var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Oval"),React.createElement("path",{"d":"M11 21.5C5.201 21.5.5 16.799.5 11S5.201.5 11 .5 21.5 5.201 21.5 11 16.799 21.5 11 21.5zm0-1a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19z","fill":"#FFF","key":1})]);
}

Circle.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Circle;

Circle.default = Circle;
